import './HowToSyncBodyFirstSteps.scss'
import { Trans, useTranslation } from 'react-i18next';
import AcVideoPlayer from '../AcVideoPlayer/AcVideoPlayer';
import { useHowToSyncContext } from '../../providers/HowToSyncProvider';

export default function HowToSyncBodyFirstSteps() {
    const { t } = useTranslation();
    const option1DataSync = t('settingsPage.howToSync.firstSteps.option1DataSync');
    const option2DataSettings = t('settingsPage.howToSync.firstSteps.option2DataSettings');
    const option2DataAddAccount = t('settingsPage.howToSync.firstSteps.option2DataAddAccount');
    const lastInfoMax = t('settingsPage.howToSync.firstSteps.lastInfoMax');
    const howToSyncContext = useHowToSyncContext();

    const openMyBlockMonth = () => {
        const win : Window | null = window.open("/my-block-month", "_blank");
        if(win) win.focus();
    }

    const openSettings = () => {
        const win : Window | null = window.open("/settings", "_blank");
        if(win) win.focus();
    }
    
    return (
        <div className='hts-body__first-steps'>
            <p className='hts-body__first-steps-title'>{t('settingsPage.howToSync.firstSteps.firstSteps')}</p>
            <p>{t('settingsPage.howToSync.firstSteps.firstStepsTitle')}</p>
            <p>
                <span className='hts-body__first-steps-options'>{t('settingsPage.howToSync.firstSteps.option1')}</span>
                <span className='hts-body__first-steps-option1'>
                    <span>{t('settingsPage.howToSync.firstSteps.option1Data1')}</span>
                    <span className='hts-body__first-steps-option--mbm' onClick={()=>openMyBlockMonth()}>{t('settingsPage.howToSync.firstSteps.option1DataMBM')}</span>
                    <span>{t('settingsPage.howToSync.firstSteps.option1Data2')}</span>
                    <span className='icon-Sync-to-Calendar hts-body__first-steps-option--icon'></span>
                    <span className='hts-body__first-steps-option--sync'>{t('settingsPage.howToSync.firstSteps.option1DataSync')}</span>
                    <span>{t('settingsPage.howToSync.firstSteps.option1Data3')}</span>
                </span>
            </p>
            <AcVideoPlayer videoUrl={howToSyncContext?.howToSyncVideos["STC_PartA.mp4"]} videoThumbnail={'../../assets/images/howToSync/thumbnail1@2x.jpg'} />
            <p>
                <span className='hts-body__first-steps-options'>{t('settingsPage.howToSync.firstSteps.option2')}</span>
                <Trans i18nKey='settingsPage.howToSync.firstSteps.option2Data'>
                    <span style={{fontWeight:600,color:'#005078',cursor:'pointer'}} onClick={()=>openSettings()}>{{option2DataSettings}}</span>
                    <span style={{fontWeight:600}}>{{option1DataSync}}</span>
                    <span style={{fontWeight:600}}>{{option2DataAddAccount}}</span>             
                </Trans>
            </p>
            <AcVideoPlayer videoUrl={howToSyncContext?.howToSyncVideos["STC_PartB.mp4"]} videoThumbnail={'../../assets/images/howToSync/thumbnail2@2x.jpg'} />
            <Trans i18nKey='settingsPage.howToSync.firstSteps.lastInfo'>
                <span style={{fontWeight:600}}>{{lastInfoMax}}</span>
                <span style={{fontWeight:600,color:'#005078',cursor:'pointer'}} onClick={()=>openSettings()}>{{option2DataSettings}}</span>             
            </Trans>        
        </div>
    )
}
